var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow"},_vm._l((_vm.urlsToDisplay),function(url,urlIndex){return _c('div',{key:urlIndex,staticClass:"slide",style:({backgroundImage: 'url(\'' + url +  '\''})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }